import * as React from 'react';

import * as styles from './styles.css';
import { IVerticalArrowProps, VerticalArrow } from '../../../VerticalArrow';

export function Arrow(props: IVerticalArrowProps) {
  return <VerticalArrow {...props} containerClass={styles['arrow']} />;
}
